import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { EqualizerDirective, EqualizerWatcherDirective } from './directives';
import { EqualizerService } from './services';

@NgModule({
    imports: [
        CommonModule,
    ],
    exports: [
        EqualizerDirective,
        EqualizerWatcherDirective,
    ],
    declarations: [
        EqualizerDirective,
        EqualizerWatcherDirective,
    ],
    providers: [
        EqualizerService,
    ],
})
export class EqualizerModule {
    public static forRoot(): ModuleWithProviders {
        return {
            ngModule: EqualizerModule,
            providers: [
                EqualizerService,
            ]
        };
    }

    public static forChild(): ModuleWithProviders {
        return {
            ngModule: EqualizerModule,
            providers: [
                EqualizerService
            ]
        };
    }
}
